
import React from 'react';
import { StyledChartContainer } from './SemiDonutChartContainer.styled';

export const SemiDonutChart = ({
    percentage,
    fillColor = '#E23D55',
    dotColor = '#FFF',
    percentageColor,
}) => {
    let convertedPercentage = 0;
    if (percentage > 180) {
        convertedPercentage = 100;
    } else {
        convertedPercentage = percentage * 100 / 180;
    }

    // Round to nearest integer.
    convertedPercentage = Math.round(convertedPercentage);

    return (
        <StyledChartContainer
            percentage={convertedPercentage}
            fillColor={fillColor}
            dotColor={dotColor}
            percentageColor={percentageColor ? percentageColor : "#FFF"}
        >
            <li>
                <span />
            </li>
        </StyledChartContainer>
    );
};